import { useEffect, useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { Button } from '../../ui-components'
import { Sanitized } from '../search/Results/utils/Sanitized'
import styled from 'styled-components'
import {
  ISelectedOption,
  LanguageDropdown,
} from '../search/AllProductsSearch/LanguagesDropdown'
import axios from 'axios'
import { capitaliseOption, getEulaUrl } from '../../helpers/utils'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { languageOptions, I18n } from 'common'

const EulaDailog = NiceModal.create(() => {
  const modal = useModal()
  const [language, setLanguage] = useState<ISelectedOption>(languageOptions[0])
  const [spinner, setSpinner] = useState<boolean>(false)
  const [conditions, setConditions] = useState<string>('')

  const disclaimerTextMap: Record<string, string> = {
    ENGLISH:
      'The English version of this document is the legally binding version. Translations in Spanish, French, or any other language are provided solely for reference purposes.',
    SPANISH:
      'La versión en inglés de este documento es la versión legalmente vinculante. Las traducciones al español, francés o cualquier otro idioma se proporcionan únicamente con fines de referencia.',
    FRENCH:
      'La version anglaise de ce document est la version juridiquement contraignante. Les traductions en espagnol, en français ou dans toute autre langue sont fournies uniquement à titre de référence.',
  }

  const onSelectLanguage = (selectedLanguage: ISelectedOption) => {
    setLanguage(selectedLanguage)
  }

  const getTermsAndConditions = async (lang: string): Promise<string> => {
    const response = await axios.get<string>(getEulaUrl(lang), {
      headers: { 'Content-Type': 'text/html' },
    })
    return response.data
  }

  useEffect(() => {
    setSpinner(true)
    getTermsAndConditions(capitaliseOption(language))
      .then((resp) => setConditions(resp))
      .finally(() => setSpinner(false))
  }, [language])

  return (
    <StyledModal
      show={modal.visible} // controlled by NiceModal
      onHide={() => modal.hide()} // hide modal
      centered
      dialogClassName="eula-modal"
    >
      <Modal.Header closeButton>
        <HeaderContainer>
          <Modal.Title>
            <I18n name="endUserLicenseAgreement" />
          </Modal.Title>
          <div className="language-wrapper">
            <LanguageDropdown
              onLanguageChange={onSelectLanguage}
              selectedLanguage={language}
            />
          </div>
        </HeaderContainer>
      </Modal.Header>

      <Modal.Body className="eula-body">
        {spinner ? <Spinner /> : <Sanitized html={conditions} />}
      </Modal.Body>

      <DisclaimerText>
        {disclaimerTextMap[language.label.toUpperCase()] ||
          disclaimerTextMap.ENGLISH}
      </DisclaimerText>

      <Modal.Footer>
        <LoginButton text="close" onClick={() => modal.hide()} />
      </Modal.Footer>
    </StyledModal>
  )
})

export default EulaDailog

const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 700px;
  }

  .modal-content {
    max-height: 80vh;
    display: flex;
    flex-direction: column;
  }

  .modal-body {
    overflow-y: auto;
    flex: 1 1 auto;
    max-height: 60vh;
    padding: 1rem 1.25rem;
  }

  .modal-body::-webkit-scrollbar {
    width: 8px;
  }
  .modal-body::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
`

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .language-wrapper {
    display: flex;
    align-items: center;
  }
`

const LoginButton = styled(Button)`
  width: 100%;
`

const DisclaimerText = styled.p`
  text-align: center;
  font-size: 16px;
  border-top: 1px solid #ddd;
  padding: 0.5rem;
`
